import { render } from "./PasswordView.vue?vue&type=template&id=6ec6a7f2"
const script = {}

import exportComponent from "C:\\Codeframe\\Dev\\cdn\\pay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__